// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"eeb4f7c2b5e3c52c0dbf","857":"e91c54a0a2f8bb5ed755","2983":"6b1f4987e70a54683ca4","5771":"a4e2a98efcfb7393c5bd","5810":"8dfb2392d7107957a510","8723":"d2d247e17fea6fb50a95"}[chunkId] + "";
};